import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import flarum from './modules/flarum';
import rocketchat from './modules/rocketchat';
import EventCategorySeenState from './modules/events/EventCategorySeenState';
import StufoeEvents from './modules/events/StufoeEvents';
import roomMembers from './modules/room-members';
import NewsList from './modules/rooms/NewsList';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        flarum,
        rocketchat,
        roomMembers,
        EventCategorySeenState,
        StufoeEvents,
        NewsList,
        user,
    },
});
